import React from "react";
import CustomerUsersTable from "./CustomerUsersTable";

const CustomerUsers = () => {
  return (
    <div>
      <CustomerUsersTable />
    </div>
  );
};

export default CustomerUsers;
